<mat-progress-spinner
  mode="indeterminate"
  *ngIf="isLoading"
  [class]="isFullSize ? 'loadingFullSize' : 'loading'"
  [ngClass]="{'absolute': isAbsolute, 'fixed': isFixed}"
></mat-progress-spinner>